import { defineMessages } from 'react-intl'

const scope = `procurify.modules.vendor.features.create-credit-card-provider.presenters.CreditCardProviderInlineCreatePresenter`

export default defineMessages({
  createSuccessToastTitle: {
    id: `${scope}.createSuccessToastTitle`,
    defaultMessage: 'Credit card provider created',
  },
  createErrorToastTitle: {
    id: `${scope}.createErrorToastTitle`,
    defaultMessage: "Credit card provider couldn't be created",
  },
  createErrorToastMessage: {
    id: `${scope}.createErrorToastMessage`,
    defaultMessage: 'Please try again or contact your system administrator.',
  },
})
